import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createJob, updateJob } from '../utils/api';
import JobForm from '../components/JobForm';
import toast from 'react-hot-toast';

export default function AddRecord() {
  const [loading, setLoading] = useState(false);
  const [savedJobId, setSavedJobId] = useState(null);
  const navigate = useNavigate();

  // Final "Save" click.
  // If the form already auto-saved this record (because the user opened the
  // Attachments/Contracts tab), UPDATE that same record instead of creating a
  // second one. Creating again is what produced duplicate/"ghost" records.
  async function handleSubmit(data) {
    setLoading(true);
    try {
      const job = savedJobId
        ? await updateJob(savedJobId, data)
        : await createJob(data);
      setSavedJobId(job.id);
      toast.success(`Record ${savedJobId ? 'updated' : 'added'}: ${job.po_number}`);
      navigate('/tracker');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save record');
    } finally {
      setLoading(false);
    }
  }

  // Auto-save silently when user clicks the Attachments / Contracts tab.
  // Only ever creates once; afterwards the id is reused by handleSubmit.
  async function handleAutoSave(data) {
    if (savedJobId) {
      const job = await updateJob(savedJobId, data);
      return job;
    }
    const job = await createJob(data);
    setSavedJobId(job.id);
    return job;
  }

  return (
    <>
      <div className="page-header">
        <h2>Add Record</h2>
        {savedJobId && (
          <button className="btn btn-outline btn-sm" onClick={() => navigate('/tracker')}>
            Go to Job Tracker
          </button>
        )}
      </div>
      <div className="page-body">
        <div className="card">
          <div className="card-body">
            <JobForm
              onSubmit={handleSubmit}
              submitLabel="Add to Tracker"
              loading={loading}
              jobId={savedJobId}
              onAutoSave={handleAutoSave}
            />
          </div>
        </div>
      </div>
    </>
  );
}
